import './App.css';
import { RouterProvider } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';

import { router } from './routing';
import { LoadingPlanProvider } from './contexts/LoadingPlanContext';
import { AuthProvider } from './contexts/AuthContext';

function App() {
  return (
    <AuthProvider>
      <SnackbarProvider autoHideDuration={3000}>
        <LoadingPlanProvider>
          <RouterProvider router={router} />
        </LoadingPlanProvider>
      </SnackbarProvider>
    </AuthProvider>
  );
}

export default App;
